<template>
    <form class="card">
        <h3>Расписание</h3>
        <Timetable :data.sync="data.booking.timetable"></Timetable>
    </form>
</template>

<script>
    import Timetable from '@/components/forms/Timetable.vue'

    export default {
        props: ['data'],
        components: {
            Timetable
        }
    }
</script>